/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Delivery
 */
export interface Delivery {
    /**
     * The data delivery mode for this object. If not specified, defaults to automatic.
     * @type {string}
     * @memberof Delivery
     */
    mode?: DeliveryModeEnum;
    /**
     * The number of records to receive per data delivery.
     * @type {number}
     * @memberof Delivery
     */
    pageSize?: number;
}


/**
 * @export
 */
export const DeliveryModeEnum = {
    OnRequest: 'onRequest',
    Auto: 'auto'
} as const;
export type DeliveryModeEnum = typeof DeliveryModeEnum[keyof typeof DeliveryModeEnum];


/**
 * Check if a given object implements the Delivery interface.
 */
export function instanceOfDelivery(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeliveryFromJSON(json: any): Delivery {
    return DeliveryFromJSONTyped(json, false);
}

export function DeliveryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Delivery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mode': !exists(json, 'mode') ? undefined : json['mode'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
    };
}

export function DeliveryToJSON(value?: Delivery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mode': value.mode,
        'pageSize': value.pageSize,
    };
}

